import { FC } from 'react'
import { format, parseISO } from 'date-fns'

import { GENERAL_TIME_FORMAT_WITH_TIMEZONE } from '$constants'

import useSignal from '$actions/useSignal'
import { profile } from '$store/profile'

import { useAuthenticatedLayout } from '../context'
import AccountInfo from '../AccountInfo'
import Menu from '../Menu'
import SidebarActionCard from '../SidebarActionCard'

import {
  container,
  info,
  menus,
  footer,
  actions,
  actionsContent,
  lastSignIn,
  joinedOn,
  joinedOnTitle,
  lastSignInTitle
} from './styles.css'
import ExtraIcon from '$icons/ExtraIcon'

export const SidebarContents: FC = () => {
  const profileStore = useSignal(profile)
  const { created_at, last_login_at } = { ...profileStore?.data }

  const {
    sidebarActions: { hasActions }
  } = useAuthenticatedLayout()

  const joinedTime = (() => {
    if (!created_at) return

    return format(parseISO(created_at), GENERAL_TIME_FORMAT_WITH_TIMEZONE)
  })()

  const lastLoginTime = (() => {
    if (!last_login_at) return

    return format(parseISO(last_login_at), GENERAL_TIME_FORMAT_WITH_TIMEZONE)
  })()

  return (
    <div className={container}>
      <div className={info}>
        <AccountInfo />
      </div>

      <div className={menus}>
        <Menu />
      </div>

      {hasActions && (
        <div className={actions}>
          <div className={actionsContent}>
            <SidebarActionCard />
          </div>
        </div>
      )}

      {joinedTime && (
        <footer className={footer}>
          <div className={joinedOn}>
            <p className={joinedOnTitle}>Joined ON</p>
            <p>{joinedTime}</p>
          </div>
          <div className={lastSignIn}>
            <div className={lastSignInTitle}>
              <ExtraIcon name="clock" width={16} />
              Last Signed In
            </div>
            <p>{lastLoginTime}</p>
          </div>
        </footer>
      )}
    </div>
  )
}

export default SidebarContents
